export default "f12eec607124eaf7.woff"